import fetch from 'isomorphic-fetch'

const API_URL_AVT = process.env.REACT_APP_AVT_API_URL

const createRequestBody = (request) => {
  return {
    method: request.method,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(request.body)
  }
}

const getStoresToChange = async (jobId, storeName) => {
  let query = ''
  if (storeName) query = `?name=${storeName}`
  const requestUrl = `${API_URL_AVT}/odin/api/job/${jobId}/change-stores${query}`

  const requestBody = createRequestBody({
    method: 'GET'
  })
  return await fetch(requestUrl, requestBody)
}

const changeJobStore = async (jobId, storeId, { comment, reason, newStoreName }) => {
  const requestUrl = `${API_URL_AVT}/odin/api/job/${jobId}/change-store/${storeId}`

  let requestBody = createRequestBody({
    method: 'PUT',
    body: {
      comment,
      reason,
      newStoreName
    }
  })
  return await fetch(requestUrl, requestBody)
}

export { getStoresToChange, changeJobStore }
